import { render } from "./NotFound.vue?vue&type=template&id=32e475e4"
const script = {}
script.render = render

export default script